module.exports = "/build/web/svg/icon-mail.456043c78b70556fa2b8e826ddb62a5a.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-mail.svg
// module id = 125
// module chunks = 13